import { render, staticRenderFns } from "./RichTextObject.vue?vue&type=template&id=45ce839a&scoped=true&"
import script from "./RichTextObject.vue?vue&type=script&lang=ts&"
export * from "./RichTextObject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce839a",
  null
  
)

export default component.exports